import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from '@ddt-web/common';
import { GenericPipesModule } from '@ddt-web/generic-utils';

import { ChartComponent } from './chart.component';

@NgModule({
	imports: [CommonModule, SharedModule, GenericPipesModule],
	declarations: [ChartComponent],
	exports: [ChartComponent]
})
export class ChartModule { }
